const config = {
  apiGateway: {
    REGION: 'us-west-2',
    PHY_LOCATION_APIGATEWAY_URL: 'https://ws1bmozql5.execute-api.us-west-2.amazonaws.com/prod',
    INTERNAL_PHY_LOCATION_APIGATEWAY_URL: 'https://75ybpynrde.execute-api.us-west-2.amazonaws.com/prod',
    COMPANY_APIGATEWAY_URL: 'https://ovxyuqbjqh.execute-api.us-west-2.amazonaws.com/prod',
  },
  reactApp: {
    VERSION: 'taxonomy-physical-location-1.16.5',
    HOSTNAME: 'https://locations.teck.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.teck.forwoodsafety.com',
    WEBSOCKET: 'wss://cvh1lv5wmh.execute-api.us-west-2.amazonaws.com/prod'
  },
};

export default config;